import { AnySection, Categories, Category, CategoryType, Group, SectionType } from '@wix/add-panel-common';
import type { Path } from './AddPanel.types';

export const getFirstLevelCategory = (categories: Categories, firstLevelId: string): Category => {
  const desiredCategory = categories.find(({ systemId }) => systemId === firstLevelId);

  if (desiredCategory) {
    return desiredCategory;
  }

  const firstNonDividerCategory = categories.find(({ type }) => type !== CategoryType.CategoryDivider);

  if (firstNonDividerCategory) {
    return firstNonDividerCategory;
  }

  return categories[0];
};

const rejectSections = (sectionsArray: AnySection[]) =>
  sectionsArray.filter((sectionDefinition) => {
    if (sectionDefinition.hide || sectionDefinition.subNavigationHide) {
      return false;
    }

    switch (sectionDefinition.type) {
      case SectionType.Theme:
        // const themeStyles = addPanelStyleManager.getThemeStylesArr(
        //   sectionDefinition.props.compTypes,
        //   editorAPI.theme,
        //   editorAPI.components,
        // );
        // return _.isEmpty(themeStyles);
        return true;

      case SectionType.Personalized:
        // const myStyles = addPanelStyleManager.getPersonalizeStylesArr(
        //   editorAPI.theme,
        //   editorAPI.components,
        //   sectionDefinition.props.compTypes,
        // );
        // return _.isEmpty(myStyles);
        return true;

      default:
        return true;
    }
  });

export const getCategoryGroups = (category: Category): Group[] =>
  category
    ? category.groups
        .map((group) => ({ ...group, sections: rejectSections(group.sections) }))
        .filter((sectionGroup) => sectionGroup.sections.length !== 0)
    : [];

export const getCategorySections = (category: Category): AnySection[] =>
  getCategoryGroups(category).flatMap((group) => group.sections);

export const getCategoryAndGroups = (categories: Categories, firstLevelId: string): [Category, Group[]] => {
  const currentCategory = getFirstLevelCategory(categories, firstLevelId);
  const groups = getCategoryGroups(currentCategory);

  return [currentCategory, groups];
};

export const getFirstSectionIdFromCategoryGroups = (groups: Group[]): string => {
  const hasGroups = Boolean(groups && groups.length > 0);

  return hasGroups ? groups[0].sections[0].systemId : '';
};

export const getCategoryFirstSection = (category: Category): AnySection => getCategorySections(category)[0];

export const getCategoryFirstVisibleSection = (category: Category): AnySection | undefined => {
  const sections = getCategorySections(category);

  return sections.find((section) => !section.subNavigationHide);
};

export const isPathToSectionExist = (path: Path, categories: Category[]): boolean => {
  const [categorySystemId, sectionSystemId] = path;
  const category = categories.find((_category) => _category.systemId === categorySystemId);

  if (!category) {
    return false;
  }

  const section = getCategorySections(category).find((_section) => _section.systemId === sectionSystemId);

  return Boolean(category || section);
};

export const pathsEqual = (p1: Path, p2: Path) => {
  if (p1.length !== p2.length) {
    return false;
  }

  return p1.every((currentChunk, index) => currentChunk === p2[index]);
};

export const findSectionInGroups = (sectionId: string, groups: Group[]) =>
  groups.flatMap((group) => group.sections).find((section) => section.systemId === sectionId);

export const getTranslationIfNeeded = (
  str: string,
  translate: (key: string) => string,
  shouldTranslate?: boolean,
): string => {
  if (shouldTranslate === false) {
    // should keep === false because it can be undefined
    return str;
  }
  return translate(str);
};
